<template>
 <div>
   <div class="bg-theme-green border-0 rounded-t-xl px-4 py-2 text-white">
      <div class="flex justify-between items-center">
          <h2 class="font-semibold leading-tight text-2xl mt-0">{{ form.name.value ? form.name.value : 'Title here' }}</h2>
          <div class="flex flex-col">
              <div class="flex justify-end items-center">
                  <button @click.prevent="update()" class="cursor-pointer rounded-md bg-white text-theme-green py-2 px-3 hover:bg-theme-darkgreen hover:text-white mr-3">
                     SAVE
                  </button>
                  <span @click.prevent="clearComponent" class="cursor-pointer rounded-md  text-white py-2 pl-1  hover:opacity-70">CLOSE</span>
                  <!-- <mdicon @click.prevent="clearComponent" size="32" name="close" class="cursor-pointer text-lg hover:opacity-60"/> -->
              </div>
          </div>
      </div>
  </div>

   <div class="pt-3 bg-[#2B2C32] px-[16px] py-[16px] rounded-lg">
      <div class="flex gap-3 xl:flex-row flex-col items-start mb-3">
          
          <div class="w-full xl:w-1/2">
            <div :class="'input-wrapper ' + (form.name.error_type)">
                <label class="text-xs mb-1">Name</label>
                <input v-model="form.name.value" @keyup="validateFields(['name'])" placeholder="Name" class="placeholder-theme-878686 block border-none rounded bg-gray-black w-full text-sm text-theme-white" type="text">
                <p class="field-error label-text mt-1" v-if="form.name.error_message" v-text="form.name.error_message"></p>
            </div>
          </div>

          <div class="w-full xl:w-1/2 flex xl:justify-end justify-start">
              <div :class="'input-wrapper ' + (form.reasonCode.error_type)">
                <label class="text-xs mb-1">Reason Code</label>
                <input v-model="form.reasonCode.value" @keyup="validateFields(['reasonCode'])" placeholder="Reason Code" class="placeholder-theme-878686 block border-none rounded bg-gray-black w-full text-sm text-theme-white" type="text">
                <p class="field-error label-text mt-1" v-if="form.reasonCode.error_message" v-text="form.reasonCode.error_message"></p>
            </div>
          </div>
      </div>

      <div class="flex gap-3 xl:flex-row flex-col items-start mb-3">
          <div class="w-full">
              <div class="input-wrapper">
                  <label class="text-xs mb-1">Description</label>
                  <div class="flex">
                      <textarea v-model="form.description" class="border-none block rounded bg-gray-black w-full text-sm"></textarea>
                  </div>
              </div>
          </div>
      </div>

  </div>

 </div>
</template>

<script lang="ts">
import {defineComponent, ref} from "vue"
import { mapGetters, mapActions, mapMutations } from "vuex";
import BusinessCategoryApis from "@/controllers/BusinessCategoryApis";
import { useSnackbar } from "vue3-snackbar";
import Helpers from '@/helpers';

  export default defineComponent({
  name: "ProductCategoryEdit",
  components: {

  },
  props: {
    clearComponent: {
      type: Function,
      required: true,
    },
  },

  setup() {
    const snackbar = useSnackbar();
    const form = <any>ref({
      businessId: '',
      name: {
        value: '',
        error_type: '',
        error_message: '',
        validations: ['required', 'min:3'],
      },
      reasonCode: {
        value: '',
        error_type: '',
        error_message: '',
        validations: ['required'],
      },
      description: "",
    })
    return {
      snackbar,
      form,
    };
  },

  computed: {
    ...mapGetters({
      vg_activeBusiness: 'auth/activeBusiness',
    }),
  },

  async mounted() {
  
  },


 
  methods: {

    /**
     * Validation captures
     */
    async validateFields(fields) {
      let res = await Helpers.validateFormFields(this.form, fields);
      // capture the fields
      this.form = res.data;
      return res.error ? false : true;
    },

   
 
    async update() {
      // validate business field
      let validate = await this.validateFields(['name', 'reasonCode']);
      if(!validate) {
        return ;
      }

      this.form.businessId = this.vg_activeBusiness.id;
      let data = <any>Helpers.getFormKeyValue(this.form);
      this.va_spinner(true);
      // let res = await BusinessCategoryApis.update(data);  
      // this.va_spinner(false);
      // this.snackbar.add({
      //   type: 'info',
      //   text: res.status == 201 ? res.data.message : Helpers.catchErrorMessage(res.response.data),
      //   duration: 3000,
      // })
      // if(res.status == 201) {
      //   this.clearComponent()
      //    this.emitter.emit("refresh-product-reasoncode-list", true);
      // }
    },
    /**
     * Do not allow to add +,-,e
     */
    preventNonNumbers(e) {
       var ASCIICode = (e.which) ? e.which : e.keyCode
      if(ASCIICode == 43 || ASCIICode == 45 || ASCIICode == 101){
        return false;
      }
      return true;
    },
    ...mapActions({
      va_spinner: 'spinner/setSpinner',
    })
  },
});

</script>
